__turbopack_context__.v({
  "centeredLayout": "Vi55aq_centeredLayout",
  "centeredLayoutInner": "Vi55aq_centeredLayoutInner",
  "isWebView": "Vi55aq_isWebView",
  "logo": "Vi55aq_logo",
  "webViewHidden": "Vi55aq_webViewHidden",
  "withLogo": "Vi55aq_withLogo",
});
